<template>
  <div class="div-container">
    <div class="intro-wrapper">
      <video playsinline autoplay muted loop preload="auto">
        <source src="/videos/home-desktop.mp4" type="video/mp4" />
        {{ $t('browser_not_support_tag') }}
      </video>
      <div class="login-wrapper">
        <div class="title-container">
          <div class="cta-container">
            <div class="cta-title">
              <span class="heading2"
                >{{ $t('welcome_to') }}&nbsp;<span class="heading2-italic"
                  >Paradise</span
                ><span v-if="isUserLogged"
                  >, {{ getAuthUser()?.value?.first_name }}</span
                >
              </span>
            </div>
            <div class="cta-subtitle">
              <span class="heading3"
                >{{ $t('limitless_travel_one_place1') }}
                <span class="heading3-italic">{{
                  $t('limitless_travel_one_place2')
                }}</span>
                {{ $t('limitless_travel_one_place3') }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <HomeCuratedExperiences @allExperiences="router.push('/experiences')" />
    <HomeParadiseExclusive @allExperiences="router.push('/experiences')" />
    <div class="show-me-wrapper" ref="header" :class="isFixed ? 'fixed' : ''">
      <div class="show-me-title" v-if="!isFixed">
        <div class="title-text">
          <span class="heading3">{{ $t('show_me') }}...</span>
        </div>
      </div>
      <div class="show-me-tabs">
        <el-tabs
          :class="!isFixed ? 'dark' : ''"
          v-model="tabActiveName"
          @tab-change="changeTab"
        >
          <el-tab-pane
            v-for="item in exploreItems"
            :key="item.value"
            :name="item.tab"
          >
            <template #label>
              <span>{{ $t(item.label) }}</span>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="show-me-content">
      <HomeShowMeOurLatestExperiences
        @allExperiences="router.push('/experiences')"
        @calculateOffset="calculateOffset"
      />
      <HomeShowMeActivities
        @allActivities="router.push('/activities')"
        @calculateOffset="calculateOffset"
      />
      <HomeShowMeNearBy />
      <HomeShowMeTours
        @allTours="router.push('/tours')"
        @calculateOffset="calculateOffset"
      />
      <HomeShowMeAccommodations
        @allAccommodations="router.push('/accommodations')"
        @calculateOffset="calculateOffset"
      />
      <HomeShowMeRestaurants
        @allRestaurants="router.push('/restaurants')"
        @calculateOffset="calculateOffset"
      />
      <HomeShowMeIconicDestinations
        @allLocations="router.push('/destinations')"
        @calculateOffset="calculateOffset"
      />
    </div>
    <UtilsHelp :white-background="true" />
    <UtilsApp />
  </div>
</template>

<script>
export default defineComponent({
  name: 'HomePage',
  setup() {
    const { width } = useBreakpoints()
    const router = useRouter()
    const route = useRoute()
    const config = useRuntimeConfig()
    const { $eventBus } = useNuxtApp()

    return {
      width,
      router,
      route,
      config,
      $eventBus
    }
  },
  data() {
    return {
      window,
      tabActiveName: 'tab-1',
      isFixed: false,
      stickyOffset: null,
      showExperiences: true,
      exploreItems: getExploreItems()
    }
  },
  computed: {
    isUserLogged() {
      return getAuthUser()?.value?.uuid ? true : false
    }
  },
  mounted() {
    setTimeout(() => {
      usePageSeo({ pageKey: 'home', locale: this.$i18n.locale })
    }, 0)
    this.calculateOffset()
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.calculateOffset)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.calculateOffset)
  },
  methods: {
    calculateOffset() {
      this.$nextTick(() => {
        this.stickyOffset = this.$refs.header
          ? this.$refs.header.getBoundingClientRect().top + window.pageYOffset
          : window.pageYOffset
      })
    },
    changeTab(event) {
      const item = this.exploreItems.find((item) => item.tab === event)
      if (item.route === this.route.fullPath) {
        this.tabActiveName = item.tab
      } else {
        this.router.push(item.route)
      }
    },
    handleScroll() {
      this.isFixed = window.pageYOffset > this.stickyOffset
    }
  }
})
</script>

<style scoped lang="scss">
.div-container {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Establece el mínimo del alto de la vista */
}
.intro-wrapper {
  background-color: black;
  video {
    /** Simulationg background-size: cover */
    @media (min-width: 1100px) {
      object-fit: cover;
    }
    @media (max-width: 1100px) {
      object-fit: cover;
    }
    height: 100%;
    width: 100%;
  }
  @media (min-width: 1100px) {
    height: 834px;
    width: 100vw;
  }
  @media (max-width: 1100px) {
    width: 100vw;
    height: 560px;
  }
}

.login-wrapper {
  position: absolute;
  top: 0;
  width: 100%;
  .title-container {
    width: 100%;
    @media (min-width: 1100px) {
      height: calc(834px - 139px);
    }
    @media (max-width: 1100px) {
      height: 560px;
    }
    display: flex;
    justify-content: center;
    align-items: center;
    .cta-container {
      z-index: 3;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      text-align: center;
      .cta-title {
        width: 100%;
        display: block;
        .heading2 {
          color: var(--brand-white);
        }
      }
      .cta-subtitle {
        @media (max-width: 1100px) {
          width: 350px;
        }
        @media (min-width: 1100px) {
          width: 520px;
        }
        display: block;
        .heading3 {
          color: var(--brand-white);
        }
      }
    }
  }
}

.show-me-wrapper {
  @media (min-width: 1100px) {
    padding: 80px 0 0 0;
  }
  @media (max-width: 1100px) {
    padding: 80px 0 0 0;
  }
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: left;
  background-color: var(--brand-white);
  .show-me-title {
    width: 100%;
    text-align: left;
    margin-bottom: 24px;
    display: block;
    position: relative;
    @media (min-width: 1100px) {
      padding-left: 96px;
      padding-right: 96px;
    }
    @media (max-width: 1100px) {
      padding-left: 24px;
      padding-right: 24px;
    }
    .title-text {
      display: inline-block;
      .heading3 {
        color: var(--brand-off-black);
      }
    }
  }
  .show-me-tabs {
    width: 100%;
    :deep(.el-tabs) {
      .el-tabs__header {
        @media (min-width: 1100px) {
          padding-left: 96px;
          padding-right: 96px;
        }
        @media (max-width: 1100px) {
          padding-left: 24px;
          padding-right: 24px;
        }
      }
    }
  }

  &.fixed {
    position: fixed;
    top: 60px;
    width: 100%;
    z-index: 3;
    padding: 0 !important;
    background-color: var(--brand-off-black);
  }
}

.tours-container,
.accommodations-container,
.restaurants-container,
.trending-destinations-container {
  background-color: var(--brand-white) !important;
}

.account-wrapper {
  height: 356px;
  background: var(--brand-off-white);
  padding: 60px 0px 80px 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  .account-icon {
    display: flex;
    justify-content: center;
    padding: 0px 24px;
    width: 100%;
    margin-top: 24px;
  }
  .account-title {
    text-align: center;
    padding: 0px 24px;
    color: var(--brand-off-black);
    width: 100%;
  }
  .account-action {
    margin-top: 24px;
    text-align: center;
    padding: 0px 24px;
    width: 100%;
  }
}
</style>